export const stripShopifyIdPrefix = (id: string): string => {
  const lastSlashIndex = id.lastIndexOf('/');
  return lastSlashIndex !== -1 ? id.substring(lastSlashIndex + 1) : id;
};
